export default "__VITE_ASSET__f405de57__"